interface MicrosoftIconProps {
	className?: string;
}

export const MicrosoftIcon = ({ className }: MicrosoftIconProps) => (
	<svg
		className={className}
		viewBox="0 0 21 21"
		aria-hidden
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Microsoft</title>
		<rect x="1" y="1" width="9" height="9" fill="#F25022" />
		<rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
		<rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
		<rect x="11" y="11" width="9" height="9" fill="#FFB900" />
	</svg>
);
